// örnek curl:

// RequestBody içerisinde dört ana obje bulunmakta.

//     * listingSelectedFields: ilan için istenilen alanların belirtildiği objedir.
//     Bu alan zorunlu değildir, request içerisinde alan belirtilmemesi durumunda ya da
//     listingSelectedFields gönderilmediği durumlarda uygun kritere sahip olan ilanların
//     tüm özellikleri response'da getirilir.
//     Tanımlanabilecek alanlar:
//         * "locationSummary",
//         * "quickInfos",
//         * "quickInfos.key",
//         * "quickInfos.name",
//         * "quickInfos.value",
//         * "location",
//         * "id",
//         * "categoryTypeName",
//         * "tradeTypeName",
//         * "estateTypeName",
//         * "title",
//         * "url",
//         * "images",
//         * "imagesFullPath",
//         * "location.summary",
//         * "location.city",
//         * "location.city.id",
//         * "location.city.name",
//         * "location.city.slug",
//         * "location.district",
//         * "location.district.id",
//         * "location.district.name",
//         * "location.district.slug",
//         * "location.locality",
//         * "location.locality.id",
//         * "location.locality.name",
//         * "location.locality.slug",
//         * "location.town",
//         * "location.town.id",
//         * "location.town.name",
//         * "location.town.slug",
//         * "location.coordinate",
//         * "roomCountName",
//         * "floorName",
//         * "squareMeter",
//         * "badges",
//         * "listingLogo",
//         * "videoUrl",
//         * "virtualTourUrl",
//         * "phoneNumber",
//         * "priceDetail",
//         * "priceDetail.trendType",
//         * "priceDetail.previousCurrency",
//         * "priceDetail.previousPrice",
//         * "priceDetail.previousValueValid",
//         * "priceDetail.currency",
//         * "priceDetail.price",
//         * "priceDetail.tlPrice",
//         * "priceDetail.alternativeValue",
//         * "priceDetail.firstPrice",
//         * "priceDetail.differenceRate",
//         * "priceDetail.squareMeterPrice",
//         * "priceDetail.opportunity",
//         * "landSubStructuralFeatures",
//         * "createdAt",
//         * "firstPublishedAt",
//         * "updatedAt"

//     * projectSelectedFields: proje için istenilen alanların belirtildiği objedir.
//     Bu alan zorunlu değildir, request içerisinde alan belirtilmemesi durumunda ya da
//     projectSelectedFields gönderilmediği durumlarda uygun kritere sahip olan projelerin
//     tüm özellikleri response'da getirilir.
//     Tanımlanabilecek alanlar:
//         * "id",
//         * "deliveryDate",
//         * "createdAt",
//         * "updatedAt",
//         * "name",
//         * "images",
//         * "locationInfo",
//         * "locationInfo.cityId",
//         * "locationInfo.cityName",
//         * "locationInfo.districtName",
//         * "locationInfo.countryId",
//         * "locationInfo.countryName",
//         * "companyName",
//         * "type",
//         * "area",
//         * "flatCount",
//         * "roomTypes",
//         * "salesStatus",
//         * "badge",
//         * "premium",
//         * "slug",
//         * "url",
//         * "price",
//         * "isImmediateDelivery",
//         * "account",
//         * "account.phoneNumber",
//         * "account.showPhone",
//         * "campaigns",
//         * "campaigns.id",
//         * "campaigns.campaignTitle",
//         * "campaigns.date",
//         * "campaigns.description",
//         * "campaigns.isBadge",
//         * "campaigns.name",
//         * "campaigns.slug",
//         * "coordinates",
//         * "tags",
//         * "category",
//         * "category.id",
//         * "category.name",
//         * "category.slug",
//         * "tradeType",
//         * "tradeType.id",
//         * "tradeType.name",
//         * "tradeType.slug",
//         * "estateType",
//         * "estateType.id",
//         * "estateType.name",
//         * "estateType.slug",
//         * "company",
//         * "company.id",
//         * "company.cover",
//         * "company.address",
//         * "company.logo",
//         * "company.introText",
//         * "company.email",
//         * "company.name",
//         * "company.slug",
//         * "company.city",
//         * "company.city.id",
//         * "company.city.name",
//         * "company.city.slug",
//         * "company.district",
//         * "company.district.id",
//         * "company.district.name",
//         * "company.district.slug",
//         * "company.phoneNumber",
//         * "company.showPhone",
//         * "company.webSite",
//         * "company.coverPhoto",
//         * "listingPhoto"

//     * otherFields: ilan ve proje alnaların haricinde ihtiyaç durumunda kullanılabilecek
//     diğer alanların belirtildiği objedir. Bu alan zorunlu değildir, request içerisinde
//     belirtilmediği durumda response'da bu alanlara ait veriler getirilmeyecektir.
//     Tanımlanabilecek alanlar:
//         * url
//         * searchCriteri"

//     * size: ilan ve proje verilenin toplam olarak kaç adet getirilmesi gerektiğini gösteren alandır.
//     min 1 ve maks 1500 arasında değer alabilir. Ayrıca bu alan zorunlu değildir, request içerisinde
//     belirtilmedi durumda varsayılan olarak 100 set edilir.

// */

const listingSelectedFields = [
  "id",
  "title",
  "imagesFullPath",
  "estateTypeName",
  "tradeTypeName",
  "roomCountName",
  "floorName",
  "squareMeter",
  "categoryTypeName",
  "priceDetail.price",
  "priceDetail.currency",
  "url",
  "phoneNumber",
  "quickInfos",
  "location.coordinate",
  "badges",
];

const projectSelectedFields = [
  "id",
  "name",
  "images",
  "companyName",
  "area",
  "flatCount",
  "salesStatus",
  "price",
  "url",
  "coordinates",
  "badge",
  "tags",
  "tradeType.name",
];

const otherFields = ["url", "searchCriteria", "name"];

export const allListingsParams = { listingSelectedFields, projectSelectedFields, otherFields, size: 1000 };

export const regionBounds = {
  20000001: {
    topRight: [42.104699, 31.013034],
    bottomLeft: [39.070559, 25.665307],
  },
  20000002: {
    topRight: [42.098063, 42.620264],
    bottomLeft: [39.849941, 30.562295],
  },
  20000003: {
    topRight: [38.703508, 43.503826],
    bottomLeft: [36.631788, 36.443416],
  },
  20000004: {
    topRight: [41.601112, 44.817845],
    bottomLeft: [36.962856, 37.266737],
  },
  20000005: {
    topRight: [38.611676, 37.76945],
    bottomLeft: [35.808592, 29.259912],
  },
  20000006: {
    topRight: [39.907043, 31.765327],
    bottomLeft: [36.293533, 26.230201],
  },
  20000007: {
    topRight: [41.081702, 38.77151],
    bottomLeft: [36.43588, 29.974983],
  },
};

export const regionCityIds = {
  20000001: [16, 17, 34, 22, 54, 39, 41, 10, 11, 59, 77],
  20000002: [67, 5, 37, 69, 8, 74, 14, 78, 81, 19, 52, 53, 55, 57, 28, 60, 29, 61],
  20000003: [2, 21, 56, 72, 73, 27, 47, 63, 79],
  20000004: [65, 4, 36, 75, 12, 44, 76, 13, 49, 23, 24, 25, 30, 62],
  20000005: [32, 80, 1, 33, 7, 46, 15, 31],
  20000006: [48, 64, 3, 35, 20, 9, 43, 45],
  20000007: [66, 68, 6, 38, 70, 71, 40, 42, 18, 50, 51, 26, 58],
};

export const initialBounds = {
  bottomLeft: [40.802689, 27.971373],
  topRight: [41.58461, 29.915705],
};

export const initialMapCenter = [41.1571550373999, 28.807353475067];
